export const overlay = () => {
    const bodyEL = $('body');
    const overlayEl = $('.js_overlay');
    $(window).on('load', function () {
        setTimeout(function () {
            bodyEL.addClass('is-overlay-active');
            overlayEl.addClass('active');
        }, 300);
    });
};
